import {Component, ElementRef, EventEmitter, ViewChild} from '@angular/core';
import MenuTogglerService from "../../services/menuToggler.service";
import * as $ from 'jquery';
import * as _ from 'lodash';
import IFilters from "../../interfaces/IFilters";
import IFilter from "../../interfaces/IFilter";
import Filters from "../../services/filters.service";

@Component({
    selector: 'top-menu',
    template: require('./topMenu.component.html'),
    styles: [String(require('./topMenu.styl'))],
    inputs: ['showDropdowns'],
    outputs: ['orderBy', 'filterBy']
})

export class TopMenuComponent {
    private orderBy = new EventEmitter();
    private filterBy = new EventEmitter();
    private showDropdowns: boolean;
    private dropdowns: IFilters;
    private isExpanded: boolean = false;

    @ViewChild('topMenu') topMenu;

    constructor(private element: ElementRef,
                private toggler: MenuTogglerService,
                private filters: Filters
    ) {
        this.dropdowns = _.pickBy(this.filters.list, (filter: IFilter, key: string) => key !== "DATE");
    }

    toggle() {
        this.toggler.toggleTopMenu();
    }

    ngAfterContentInit() {
        this.toggler.topMenu = $(this.element.nativeElement)['find']('.topMenu');
        this.toggler.preserveToggle();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/topMenu/topMenu.component.ts